import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from "react-router-dom";
import {Button, FloatButton, Table, TableProps} from "antd";
import {AuthContext} from "../../../../config/AuthContext";
import JutgeColors from "../../../../styles/JutgeColors";
import {ColumnsType} from "antd/es/table";
import {BiArrowFromLeft, BiCheck, BiPen, BiPencil, BiPlus, BiRefresh} from "react-icons/bi";
import {GetProjectes} from "../../../../dao/abp/GetProjectes";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import ProjecteModal from "../ProjecteModal";
import {BsPersonCheck} from "react-icons/bs";

const Configuracio = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    const [dades, setDades] = useState<any[]>([]);
    const [pantalla, setPantalla] = useState(0);
    const [loading, setLoading] = useState(false);
    const [projectes, setProjectes] = useState<any[]>([]);
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState<any>();


    useEffect(() => {
        if (isLoggedIn) {
            setBreadCrumb([{nom: 'Home', nav: '/home'},
                {nom: 'avaluacio', nav: '/abp'},
                {nom: 'configuració', nav: '/abp/configuració'}], true);
            checkDades();
        }
    }, []);

    async function checkDades() {
        setLoading(true); // Mostrar la barra de progreso

        if (user.tipus === "0") {
            const userIdStr = userId ? userId.toString() : "";
            const practices = await GetProjectes(userIdStr);
            setProjectes(practices);
        }
        setLoading(false); // Ocultar la barra de progreso cuando los datos se cargan
    }

    function navegar(ele: any) {
        if ((user.tipus === "0"))
            navigate(`/abp/projectes/${ele.id}`);
    }

    function toggle(ele: any) {
        if ((user.tipus === "1" || user.tipus === "0"))
            alert("TODO: activar/desactivar");
    }


    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 30,
        },
        {
            key: 'descripcio',
            dataIndex: 'descripcio',
            width: 30,
        },
        {
            key: 'data_ini',
            dataIndex: 'data_ini',
            width: 30,
        },
        {
            key: 'data_fi',
            dataIndex: 'data_fi',
            width: 30,
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 10,
            render: (estat, ele) => (
                <>
                    <Button title={"Accedir"} onClick={() => navegar(ele)}
                            style={{backgroundColor: AvaluacioColors.colors.color6}}><BiArrowFromLeft/></Button>
                    {" "}
                    <Button title={"Activar/Desactivar"} onClick={() => toggle(ele)}
                            style={{backgroundColor: AvaluacioColors.colors.color4}}><BiCheck/></Button>
                </>
            ),
        },
    ];

    function onClose() {
        setModal(false);
    }


    const tableProps: TableProps<any> = {
        loading
    };


    return (
        <>
            <Table
                showHeader={false}
                size={"small"}
                title={() => "PROJECTES"}
                {...tableProps}
                bordered={true}
                columns={columns}
                dataSource={projectes}
            />


            <FloatButton
                shape="circle"
                onClick={() => setModal(true)}
                style={{ insetInlineEnd: 94, backgroundColor: AvaluacioColors.colors.color6 }}
                icon={<BiPlus />}
            />



            {!loading && <FloatButton
                shape="circle"
                onClick={() => checkDades()}
                style={{ insetInlineStart: 97, backgroundColor: AvaluacioColors.colors.color6 }}
                icon={<BiRefresh />}
            />}

            {modal && <ProjecteModal element={selected} visible={modal} onClose={onClose} /> }
        </>
    );
};

export default Configuracio;
